import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

/** The layout under `/ws/olivia`: guarded by her own entry (`olivia:read`, and her plan). */
export const Route = createFileRoute("/_authenticated/ws/olivia")({
  beforeLoad: ({ context }) => guardRoute(context.me, "workforce-agent"),
  component: Outlet,
});
